import { Component } from '@angular/core';
import { NavController, MenuController, Platform } from 'ionic-angular';
import { HomePage } from "../home/home";
import { LoginPage } from "../login/login";
import { UserService } from "../../providers/session-service/user-service";
import { RegisterPage } from "../register/register";

@Component({
    selector: 'page-landing',
    templateUrl: 'landing.html',
})
export class LandingPage {

    constructor(public platform: Platform, public navCtrl: NavController, private userService: UserService, 
        private menu: MenuController) {
        this.menu = menu;
        this.menu.enable(false);

        this.platform = platform;

        
    }

    login(loginMethod: any) {
        if (loginMethod === "player") {
            this.navCtrl.push(LoginPage);
        } else if (loginMethod === "guest") {
            this.userService.startGuestSession();
            this.navCtrl.setRoot(HomePage);
        }
    }

    switchToRegister() {
        this.navCtrl.push(RegisterPage);
    }
}



// WEBPACK FOOTER //
// ./src/pages/landing/landing.ts